<div
    *ngIf="totalItems > 0"
    class="app-table-pagination-bar row d-flex"
    [ngClass]="containerClass"
>
    <div class="col-md-3 col-12">
        <div class="d-flex flex-column gap-1">
            <label class="d-flex align-items-center app-table-pagination-bar__afficher">
                Afficher
                <select
                    class="form-control app-table-pagination-bar__select" style="width: 80px"
                    [ngModel]="pageSize"
                    (ngModelChange)="onPageSizeSelect($event)"
                    [name]="'appTablePagination-' + nameSuffix"
                >
                    <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}</option>
                </select>
            </label>

        </div>
    </div>
    <div class="col-md-9 col-12 app-table-pagination-bar__col">
        <div
            class="app-table-pagination-bar__pagination-row d-flex justify-content-end gap-2"
            role="navigation"
            [attr.aria-label]="ariaLabel"
        >
            <button
                type="button"
                class="page-box"
                [class.disabled]="currentPage === 1"
                [disabled]="currentPage === 1"
                (click)="goFirst()"
                aria-label="Première page"
            >
                «
            </button>
            <button
                type="button"
                class="page-box"
                [class.disabled]="currentPage === 1"
                [disabled]="currentPage === 1"
                (click)="goPrev()"
                aria-label="Page précédente"
            >
                ‹
            </button>
            <button
                type="button"
                *ngFor="let page of pageNumbers"
                class="page-box"
                [class.active]="page === currentPage"
                (click)="goToPageNum(page)"
                [attr.aria-current]="page === currentPage ? 'page' : null"
            >
                {{ page }}
            </button>
            <button
                type="button"
                class="page-box"
                [class.disabled]="currentPage === totalPages"
                [disabled]="currentPage === totalPages"
                (click)="goNext()"
                aria-label="Page suivante"
            >
                ›
            </button>
            <button
                type="button"
                class="page-box"
                [class.disabled]="currentPage === totalPages"
                [disabled]="currentPage === totalPages"
                (click)="goLast()"
                aria-label="Dernière page"
            >
                »
            </button>
        </div>
    </div>
</div>
